import {Component, OnDestroy, OnInit} from '@angular/core';
import {AppAlertService, SubtitlesService} from "../core";
import {Subscription} from "rxjs";

@Component({
    selector: 'not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit, OnDestroy {
    hasSubtitles = false;
    private subtitlesSubscription: Subscription;

    constructor(
        private appAlert: AppAlertService,
        private subtitles: SubtitlesService
    ) {
    }

    ngOnInit() {
        this.subtitlesSubscription = this.subtitles.subtitlesChanged$.subscribe((newValue) => {
            if (newValue && !this.hasSubtitles) {
                this.hasSubtitles = true;
                this.appAlert.showAppAlert(this.subtitles.setSubtitle(7343),
                    this.subtitles.setSubtitle(1233),
                    this.goBack.bind(this), false, null);
            }
        });
    }

    ngOnDestroy() {
        if (this.subtitlesSubscription) {
            this.subtitlesSubscription.unsubscribe();
        }
    }

    private goBack(): void {
        window.history.back();
    }
}
